import React from "react";
import { HStack, Button, Text } from "@chakra-ui/react";

type ChangePagesProps = {
  page: number;
  setPage: (value: React.SetStateAction<number>) => void;
  totalPages: number | undefined;
};

export function PageSwitcher({ page, setPage, totalPages }: ChangePagesProps) {
  const canClickPrevious = page > 1;
  const canClickNext = totalPages === undefined ? false : page < totalPages;
  if (canClickPrevious || canClickNext) {
    return (
      <HStack marginTop="8px" marginBottom="8px" justifyContent="space-between">
        <Button
          colorScheme="primary"
          variant="ghost"
          onClick={() =>
            canClickPrevious ? setPage((current) => current - 1) : undefined
          }
          cursor={canClickPrevious ? "auto" : "not-allowed"}
          disabled={!canClickPrevious}
        >
          ← Previous
        </Button>
        {totalPages ? (
          <Text>
            Page <Text as="strong">{page}</Text> out of{" "}
            <Text as="strong">{totalPages}</Text>.
          </Text>
        ) : undefined}
        <Button
          colorScheme="primary"
          variant="ghost"
          onClick={() =>
            canClickNext ? setPage((current) => current + 1) : undefined
          }
          cursor={canClickNext ? "auto" : "not-allowed"}
          disabled={!canClickNext}
        >
          Next →
        </Button>
      </HStack>
    );
  }
  return null;
}
